import { Button } from '@/shared/Button';
import { useContext } from 'react';
import Image from 'next/image';
import spinnerIcon from '@/assets/vectors/icons/spinner.svg';
import { ExportContext } from '../ExportCompound.context';

export const DownloadMap = (): React.ReactNode => {
  const { handleDownloadMap, data } = useContext(ExportContext);

  return (
    <div className={`mt-6 ${data.graphicsMapToggle ? 'visible' : 'hidden'}`}>
      <Button onClick={handleDownloadMap} disabled={data.isDownloadingMap}>
        {data.isDownloadingMap && (
          <Image
            src={spinnerIcon}
            alt="spinner icon"
            height={12}
            width={12}
            className="mr-5 animate-spin"
          />
        )}
        Download map
      </Button>
    </div>
  );
};
